import React, { Component } from 'react';
import LoginBasic from '../components/LoginBasic';
import { history } from '../services/history';
import { connect } from 'react-redux';
import { login, signOut } from '../../actions/userActions';
import { CircularProgress } from '@material-ui/core';

class LoginContainer extends Component {
    componentDidMount() {
        this.props.signOut({})
    }

    handleLoginAction = (mail, password) => {
        const resolve = path => history.push(path);
        const reject = error => alert("Error en los datos. Vuelve a intentarlo");

        this.props.login({ mail, password, resolve, reject });
    }

    render() {
        const { loading } = this.props;

        return (
            <div>
                { loading ? 
                    <CircularProgress /> : 
                    <LoginBasic handleLoginAction={this.handleLoginAction}></LoginBasic>
                }
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    login: payload => dispatch(login(payload)),
    signOut: payload => dispatch(signOut(payload))
});

const mapStateToProps = state => ({
    loading: state.user.loading
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);